import { SharedListUploadResult } from '../sharedList'
import { WeekDay } from 'shared/weekDay'

export const SpecialProducts = [
	{ productId: 9998, productName: '新規製剤' },
	{ productId: 9999, productName: '製剤以外' }
]

export const MrpPredictionServiceTypes = {
	'mrp': 'MRPlus',
	'portal': 'ポータルページ',
	'link': 'リンク'
}
export type MrpPredictionServiceType = keyof typeof MrpPredictionServiceTypes

export const MrpPredictionContentsTypes = {
	'movie': '動画',
	'pdf': 'PDF',
	'html': 'HTML',
	'mixed': '複合'
}
export type MrpPredictionContentsType = keyof typeof MrpPredictionContentsTypes

export const MrpPredictionRecommendPriolities = {
	'preferred': '表示しない',
	'normal': '表示する',
}
export type MrpPredictionRecommendPriolity = keyof typeof MrpPredictionRecommendPriolities

export const MrpPredictionAreaMrpTypes = {
	'no': '無効',
	'yes': '有効',
	'company': '有効（カンパニーページのみ）'
}
export type MrpPredictionAreaMrpType = keyof typeof MrpPredictionAreaMrpTypes

export type MrpPredictionFormData = {
	productId?: number[]
//	startDate?: string | null
//	closeDate?: string | null
	startWeekday?: WeekDay
	startHour?: number
	days?: number
	serviceType?: MrpPredictionServiceType
	contentsType?: MrpPredictionContentsType
	contentsDuration?: number
	completeUp?: number
	recommendPriolity?: MrpPredictionRecommendPriolity
	areaMrp?: MrpPredictionAreaMrpType,
	categoryCode?: string[]
	bigTagId?: number[]
}

export type LvPredictionFormData = {
	productId?: number[]
	reservationDays?: number
//	broadcastStart?: Date | null
	broadcastWeekday?: WeekDay
	broadcastHour?: number
	broadcastDuration?: number
	reservationUp?: number
	viewUp?: number
	isAreaLec?: boolean
	providerCode?: string
}

export type PredictionResult = {
	predictedViewRate: number
}

export type PredictionSource = 'mrp' | 'lv'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PredictionCondition<T extends PredictionSource = any> = {
	source: PredictionSource
	hash?: string
	text?: string
} & (
	T extends 'mrp' ? MrpPredictionFormData :
	T extends 'lv' ? LvPredictionFormData : unknown
)
export type PredictionConditionMrp = PredictionCondition<'mrp'>
export type PredictionConditionLv = PredictionCondition<'lv'>

export type PredictionData = {
	uploadResult: SharedListUploadResult
	predictionCondition: PredictionCondition
	predictionResult: PredictionResult
}
